import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { sectorslist } from 'src/app/shared/services/sectors.service';
import { statuslist, StatusService } from 'src/app/shared/services/status.service';
import { Region, RegionsService } from 'src/app/shared/services/regions.service';
import { Users, SalesService } from 'src/app/shared/services/sales.service';
import { BoardsService } from 'src/app/services/boardsPage/boards.service';
import { OpportunitiesService } from '../../../services/opportunitiesPage/opportunities.service';
import { Filters } from 'src/app/services/boardsPage/filters-data';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})

export class FilterComponent implements OnInit {

  //@Input("checkboxYear") checkboxYear : any[];
  @Input("statusList") statusList : statuslist[];
  @Input("regionsList") regionsList : Region[];
  @Input("sectors") sectors : sectorslist[];
  @Input("salesUsers") salesUsers : Users[];
  @Input("customerNameList") customerNameList : any[];
  @Input("opportunityNameList") opportunityNameList : any[];
  
  @Input("displayProductKindCheckBoxes") displayProductKindCheckBoxes : boolean;
  @Input("filterForPage") filterForPage : string;

  @Output("onCheckBoxClicked") checkBoxClicked : EventEmitter<any> = new EventEmitter();
  @Output("onDropDownClicked") dropDownClicked : EventEmitter<any> = new EventEmitter();
  @Output("onResetClick") resetClicked : EventEmitter<any> = new EventEmitter();
  @Output("filterClicked") filterButtonClicked : EventEmitter<any> = new EventEmitter();
   
  constructor(private opportunitiesService: OpportunitiesService,private boardsService: BoardsService, private statusService: StatusService, private regionService:RegionsService, private salesService: SalesService) { }
  
  public checkboxYear: any[] = [
    { key: "", value: false },
    { key: "", value: false },
    { key: "", value: false },
    { key: "", value: true },
    { key: "", value: false } 
]
  filterIsToggled = true;
  currentYear: number;
  public errorMsg;
  filters : Filters;
  quarter1 : boolean;
  quarter2 : boolean;
  quarter3 : boolean;
  quarter4 : boolean;
  swgType : boolean;
  stgType : boolean;
  sbmnss : boolean;
  sbmcss : boolean;
  genericStatus : string;
  month1 : boolean;
  month2 : boolean;
  month3 : boolean;

  async ngOnInit(): Promise<void> {
    await this.retrieveFilters();
    await this.generateYears();
    this.populateQuarters();
    this.populateProductKind();
    this.populateSbmChannel();
    this.populateMonths();
    this.filterClicked('clicked');
  }

  populateMonths() {
    // console.log(this.filters.month);
    if (this.filters.month!=undefined && this.filters.month!=null){
      if (this.filters.month.indexOf("1")!=-1){
        this.month1=true;
      }
      if (this.filters.month.indexOf("2")!=-1){
        this.month2=true;
      }
      if (this.filters.month.indexOf("3")!=-1){
        this.month3=true;
      }
      
   }
  }


  
  populateSbmChannel() {
    // console.log(this.filters.sbmchannel);
    if (this.filters.sbmchannel!=undefined && this.filters.sbmchannel!=null){
      if (this.filters.sbmchannel=="All"){
        this.sbmnss = false;
      }
      else if (this.filters.sbmchannel=="SBM-NSS"){
          this.sbmnss= true;
      }
      else if (this.filters.sbmchannel=="SBM-CSS"){
        this.sbmcss= true;
    }
      else {
        this.sbmnss = false;
      }
    }
  }

  
  populateProductKind() {
    
    if (this.filters.productKind!=undefined && this.filters.productKind!=null){

      for (let index = 0; index < this.filters.productKind.length; index++) {
        const element = this.filters.productKind[index];
        if (element=="SWG"){
          this.swgType = true;
        }
        else if (element=="STG"){
          this.stgType = true;
        }
      }
    }
  }

  populateQuarters() {
   if (this.filters.quarter!=undefined && this.filters.quarter!=null){
      if (this.filters.quarter.indexOf("1")!=-1){
        this.quarter1=true;
      }
      if (this.filters.quarter.indexOf("2")!=-1){
        this.quarter2=true;
      }
      if (this.filters.quarter.indexOf("3")!=-1){
        this.quarter3=true;
      }
      if (this.filters.quarter.indexOf("4")!=-1){
        this.quarter4=true;
      }
   }
  }

  async retrieveFilters() {
    if (this.filterForPage == 'opportunities'){
      this.filters =  this.opportunitiesService.getFilters();
    }
    else {
      this.filters =  this.boardsService.getFilters();
    }
    // console.log(this.filters);
  }

  async generateYears() {
    this.currentYear = new Date().getFullYear();
    //this.yearsList = [];
    let arr =[];
    let count=0;
    let years = this.filters.year;
    // console.log(years);
    //console.log(years.length);
    for (let index = -2; index < 3; index++) {
      
      this.checkboxYear[count].key=this.currentYear+index;
     // let yearKey : string = ""+this.checkboxYear[count].key;
      //console.log(yearKey);
     // console.log(yearKey in years);
      if (this.currentYear == (this.currentYear+index)){
        this.checkboxYear[count].value=true;
      }     
      else {
        this.checkboxYear[count].value=false;  
      }

      for (let index = 0; index < years.length; index++) {
        const element = years[index];
        if ( this.checkboxYear[count].key == element){
            this.checkboxYear[count].value=true;
        }
      }

           
      count++;
      //this.yearsList.push(this.currentYear+index);
    }
    //console.log(this.checkboxYear);
    //throw new Error("Method not implemented.");
  }
  
  public onResetClick(event: any){
    // console.log("reset clicked of child component called............");
    var yearul = <HTMLInputElement> document.getElementById("year-"+this.currentYear);
    yearul.checked=true;
    event.target.id="year";
    this.resetClicked.emit(event);
  }
  
  public onCheckBoxClicked( event: any){
   // console.log("onCheckBoxClicked called in fiter component");
   // console.log(event);
    this.checkBoxClicked.emit(event);
  }

  public onDropDownClicked(  event: any , type:string ){
    event.elementType = type;
    this.dropDownClicked.emit(event);
  }

  public onDropDownClickedObject(  event: any , type:string , selectedObject: any){
    event.selectedObject = selectedObject;
    this.onDropDownClicked(event,type);   
  }

  public filterClicked(event: any){
    this.filterIsToggled=!this.filterIsToggled;
    this.filterButtonClicked.emit(event);
  }

}
